module.exports = __webpack_public_path__ + "91ed9a01fbe8936ffd81d0b62400c999.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PFDinTextPro-Medium.ttf
// module id = 49
// module chunks = 0